import React from "react"
import { Script } from "gatsby"

function HeadScripts(options) {
  const { googleTagManagerId } = options
  const scripts = [] as any

  if (process.env.NODE_ENV === `production` && googleTagManagerId) {
    scripts.push(
      <Script
        src={`https://www.googletagmanager.com/gtm.js?id=${googleTagManagerId}`}
        forward={[`dataLayer.push`]}
      />,
      <Script id="gtm-init">
        {`
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({ 'gtm.start': new Date().getTime(), 'event': 'gtm.js' })
        `}
      </Script>
    )
  }

  return <>{scripts}</>
}

export default HeadScripts
